define(function(require,exports,module){
    var feetDashInches = require( '../math/feetDashInches' ),
        baseDims = require( './baseDims' );

    var BASE_FOOT = 12,
        PIXEL_FOOT = 75,
        EYE_TO_SCREEN = 10,
        PLATE_WIDTH = 17/BASE_FOOT,
        interpolatedPlateWidth = PLATE_WIDTH * PIXEL_FOOT,
        interpolatedPlateFront = PLATE_WIDTH * PIXEL_FOOT,
        PERSPECTIVE_SHIFT_Y  = 186;

    return {
        className       : "responsive-pitch-fx",
        diagnostics     : false,
        font            : "gd-primary-bold, Helvetica Neue Bold, HelveticaNeue-Bold, Helvetica, Arial",
        fontSize        : 70,
        ballSize        : 2.90,
        batterScaling   : true,
        hotColdZones    : true,
        defaultStrikezone: false,
        fadeOldPitches  : false,
        smoothing       : true,
        domBalls        : false,
        renderBallsInDirt: true,
        hoverData       : true,
        hoverDataTarget : 'body',
        snapshot        : false,
        batter          : true,
        mode            : '3d',
        trails          : true,
        tiltShift       : false,
        oldTimey        : false,
        clip            : false,
        renderURI       : false,
        vector          : false,
        grid            : false,
        perspective: 'catcher',
        type            : 'front',
        pixelFoot       : PIXEL_FOOT,
        foot            : BASE_FOOT,
        eyeToScreen     : EYE_TO_SCREEN,
        canvasDensity   : (window.devicePixelRatio || 2.0).toFixed(2)*1,
        homePlateWidth  : PLATE_WIDTH,
        homePlateFrontY : PLATE_WIDTH,
        homePlateBackY  : 0,
        interpolatedPlateWidth : interpolatedPlateWidth,
        interpolatedPlateFront : interpolatedPlateFront,

        dirtCloud       : {
            width: 136,
            height: 60
        },

        base_width      : baseDims.width,
        base_height     : baseDims.height,

        // Animation
        numberOfAnimationPoints: 1000 / 40,
        timing          : 1000 / 36,

        //use for 2D pitch, from ipad...
        x_center        : 0.5,
        y_center        : 0.5,

        x_offset        : 0,
        y_offset        : PERSPECTIVE_SHIFT_Y,

        adjust2d : {
            width   : 1.14,
            x       : PLATE_WIDTH,// / baseDims.width,
            y       : PLATE_WIDTH, // baseDims.height,
            margin  : -30 / baseDims.height
        },
        batterHeight    : feetDashInches("6' 0"),

        /*  Ratio of batter height/width to field height/width as percentage */
        batterX         : 20.5,//      / 100,
        // batterY         : 60,//     / 100,

        batterLR        : 26.5,//   / 100,

        batterTop       : 27.8,// / 100,


        // batterLR: 234.4959,
        // batterLeft : 554.496,
        strikeZone      : {
            szBot       : 1.47,
            szTop       : 3.55  // 3.8 at eye to screen 10
        },
        ballStrokeWidth : 1,
        szBorder        : 0,
        szPadding       : 50,
        eyetoScreen     : EYE_TO_SCREEN,
        viewBottomMargin: PERSPECTIVE_SHIFT_Y,
        perspectiveShiftY : PERSPECTIVE_SHIFT_Y,

        smoothing: 'high',
        hotColdZoneGridStroke:  1,
        hotColdZoneBorderStroke:  0,
        hotColdZoneGridOpacity: 1.0,
        hotColdZoneColorOpacity: 0.8,
        hotColdZoneDefaultColor : "rgba(255, 255, 255, 0.55)",
        hotColdZoneOutlierDefaultColor : "rgba(200, 200, 200, 0.55)",
        hotColdZoneGridColor : "rgba(0, 0, 0, 1.0)",
        hotColdZoneBorderColor : "rgba(0, 0, 0, 0)",
        hotColdZoneOutlierBorderColor : 'rgba(0, 0, 0, 0)',
        strikeZoneBorderColor : "rgba(0, 0, 0, 1.0)",
        backgroundGridColor : "rgba(108, 140, 169, 0.4)",
        ballStrokeColor: "rgba(0, 0, 0, 0.32)",
        ballColorStrike: false,
        ballColorBall: false,
        ballColorInPlay: false,
        ballColorInPlayOuts: false,
        ballTextColor: "rgba(255, 255, 255, 1.0)"
    };
});
